module.exports = __webpack_public_path__ + "img/guided-tour.a223c53a.png";